import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';
import TribunChangeNickName from '../Views/TribunChangeNickName';
import Icon from 'Components/Icon';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { getTribunUserAgreement } from 'Store/actions';
import { openModal } from 'Store/actions';
import { getTribunTermOfUse } from 'Store/actions';

const TribunLoginSuccessModal = props => {

  const dispatch = useDispatch();
  
  const tribunKvkkContainer = classnames({
    'tribun-kvkk ': true,
    container: !props.showCsp
  });


  const tribunKvkkDiv = (<><div className={ tribunKvkkContainer }>
    <Icon iconName="svgInfoDarkGrey" />
    <div className="tribun-kvkk loginSuccessModal">
    Tribün kullanımınız kapsamında işlenecek olan kişisel verilerinize yönelik hazırlanmış
      <span><span className="modalUserAgreement" onClick={ () => {
        dispatch(getTribunUserAgreement());
        dispatch(openModal('tribunKvkkModal'));
      }
      }> { 'Aydınlatma Metni' }</span><span>{ "'ni okumak için tıklayınız." }</span></span>
    </div></div>
    <div className={ tribunKvkkContainer }>
      <Icon iconName="svgInfoDarkGrey" />
      <div className="tribun-kvkk loginSuccessModal">
        <span><span className="modalUserAgreement" onClick={ () => {
          dispatch(getTribunTermOfUse());
          dispatch(openModal('tribunTermOfUseModal'));
        }
        }>{ EnvironmentManager.getMessageText({ key: 'tribun_TermsOfUse' }) || 'Tribün kullanım koşulları' }</span><span>{ "'nı okumak için tıklayınız." }</span></span>
      </div></div></>);

  const successMessage = EnvironmentManager.getMessageText({ key: 'tribun_ilk_giris_popup' });

  const [firstLine, ...rest] = successMessage.split('<br><br>');

  return (
    <Message type="none">
      { props.showCsp
        ? <>
        <span className="username">{ props?.tribunLoginSuccessUserName + ' ' }</span>
      <span className="first-line">{ firstLine }</span>
      <br/>
      <div className="success-message" dangerouslySetInnerHTML={ { __html: rest.join('<br><br>') } }/>
        </>
        :       <><span className="username">{ props?.tribunLoginSuccessUserName + ' ' }</span><br/>
  <span dangerouslySetInnerHTML={ { __html: successMessage } } /></>

      }

      { props?.tribunLoginSuccessUserName && <TribunChangeNickName
        originalNickName={ props?.tribunLoginSuccessUserName }
        getTribunSettings = { false }
        tribunKvkkDiv = { tribunKvkkDiv }
        onPrimaryButtonClick = { props.onPrimaryButtonClick }
      /> }
    </Message>
  );
};

TribunLoginSuccessModal.propTypes = {
  userName: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func.isRequired,
  tribunLoginSuccessUserName: PropTypes.string,
  openModal: PropTypes.func,
  getTribunUserAgreement: PropTypes.func,
  getTribunTermOfUse: PropTypes.func,
  showCsp: PropTypes.bool
};

export default TribunLoginSuccessModal;


